import { CaseDocumentWithPresignedUrl } from "pwapi";

import { LIS } from "shared/actions/constants";
import { PWAction } from "shared/utils/redux";

type StationDocumentState = {
  open: boolean;
  document?: CaseDocumentWithPresignedUrl | null;
};

const initialState = {
  open: false,
  document: null,
};

const stationDocumentReducer = (
  state: StationDocumentState = initialState,
  action: PWAction
): StationDocumentState => {
  switch (action.type) {
    case LIS.DOCUMENT.STATION_DOCUMENT.REQUEST:
    case LIS.DOCUMENT.STATION_DOCUMENT.ERROR:
      return {
        ...state,
        open: false,
        document: null,
      };
    case LIS.DOCUMENT.STATION_DOCUMENT.SUCCESS:
      return {
        ...state,
        open: true,
        document: action.payload.response,
      };
    default:
      return state;
  }
};
export default stationDocumentReducer;
